export default __webpack_public_path__ + "static/media/khachapuri.82076594.png";